<template>
    <div class="welmshome">
        <Head />
        <div class="welmshome-box1">
            <!-- <h3>DIGITALLY TRANSFORM EDUCATION FROM SCRATCH WITH WEIDONG </h3> -->
            <!-- <p>Methodologies, infrastructure, hardware, software platform and content, all these aspects working in concert create an optimal learning ecosystem which motivates digital transformation in education. </p> -->
            <div class="top-box">
                <div class="video">
                    <video-player 
                        class="video-player-box"
                        ref="videoPlayer"
                        :options="playerOptions"
                        :playsinline="true"
                    >
                    </video-player>
                </div>
                <div class="text  animated fadeIn">
                    <img class="welms_logo" src="../../assets/welmsHome/welms_logo.png" alt="">
                    <div class="welms-desc">
                        <div>{{$t('welms.col1.i1')}}</div> 
                         <div>{{$t('welms.col1.i2')}}</div> 
                        <div>{{$t('welms.col1.i3')}}</div> 
                    </div>
                    <div  class="email-btn learn-more-hover" @click="show = !show">
                        <span class="more-img-outer"></span>
                        <span class="more-right-word" style="text-align: left" v-html="$t('welms.col1.i4')"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="welmshome-box2 node-anchor" ref="animate1">
            <h4 :class="{'animated fadeInUp': animate1}">{{$t('welms.col2.i1')}}</h4>
            <div class="text1" :class="{'animated fadeInUp delay-1s': animate1}">
                {{$t('welms.col2.i2')}} 
            </div>
            <div class="text2" :class="{'animated fadeInUp delay-1s': animate1}">
                {{$t('welms.col2.i3')}}
            </div>
        </div>
        <div class="welmshome-box3" ref="animate2">
            <h4 :class="{'animated fadeIn': animate2}">{{$t('welms.col2.i4')}}</h4>
            <p :class="{'animated fadeInUp delay-1s': animate2}">{{$t('welms.col2.i5')}}</p>
            <ul class="table" :class="{'animated fadeInUp delay-1s': animate2}">
                <li class="li1">{{$t('welms.col2.i6')}}</li>
                <li class="li2">{{$t('welms.col2.i7')}}</li>
                <li class="li3">{{$t('welms.col2.i8')}}</li>
                <li class="li4">{{$t('welms.col2.i9')}}</li>
                <li class="li5">{{$t('welms.col2.i10')}}</li>
                <li class="li6">{{$t('welms.col2.i11')}}</li>
                <li class="li7">{{$t('welms.col2.i12')}}</li>
                <li class="li8">{{$t('welms.col2.i13')}}</li>
                <li class="li9">{{$t('welms.col2.i14')}}</li>
                <li class="li10">{{$t('welms.col2.i15')}}</li>
                <li class="li11">{{$t('welms.col2.i16')}}</li>
                <li class="li12">{{$t('welms.col2.i17')}}</li>
                <li class="li13">{{$t('welms.col2.i18')}}</li>
                <li class="li14">{{$t('welms.col2.i19')}}</li>
            </ul>
        </div>
        <div class="welmshome-box4" >
            <div class="title" ref="animate3" :class="{'animated fadeInLeft': animate3}">
                <p>{{$t('welms.col3.i1')}}</p>
                <b>|</b>
                <p>{{$t('welms.col3.i2')}}</p>
            </div>
            <div class="content" :class="{'animated fadeInDown delay-1s': animate3}">
                <div class="content-box c-box1">
                    <img src="../../assets/welmsHome/welms_icon1.png" alt="">
                    <p>{{$t('welms.col3.i3')}}</p>
                    <li><b></b><span>{{$t('welms.col3.i4')}}</span></li>
                    <li><b></b><span>{{$t('welms.col3.i5')}}</span></li>
                    <li><b></b><span>{{$t('welms.col3.i6')}}</span></li>
                    <li><b></b><span>{{$t('welms.col3.i7')}}</span></li>
                    <li><b></b><span>{{$t('welms.col3.i8')}}</span></li>
                </div>
                <div class="content-box c-box2">
                    <img src="../../assets/welmsHome/welms_icon2.png" alt="">
                    <p>{{$t('welms.col3.i9')}}</p>
                    <li><b></b><span>{{$t('welms.col3.i10')}}</span></li>
                    <li><b></b><span>{{$t('welms.col3.i11')}}</span></li>
                    <li><b></b><span>{{$t('welms.col3.i12')}}</span></li>
                </div>
                <div class="content-box c-box3">
                    <img src="../../assets/welmsHome/welms_icon3.png" alt="">
                    <p>{{$t('welms.col3.i13')}}</p>
                    <li><b></b><span>{{$t('welms.col3.i14')}}</span></li>
                    <li><b></b><span>{{$t('welms.col3.i15')}}</span></li>
                </div>
                <div class="content-box c-box4">
                    <img src="../../assets/welmsHome/welms_icon4.png" alt="">
                    <p>{{$t('welms.col3.i16')}}</p>
                    <li><b></b><span>{{$t('welms.col3.i17')}}</span></li>
                    <li><b></b><span>{{$t('welms.col3.i18')}}</span></li>
                </div>
            </div>
        </div>
         <div class="welmshome-box5">
            <h4 ref="animate4" :class="{'animated fadeIn': animate4}">{{$t('welms.col4.i1')}}</h4>
            <div class="cont" :class="{'animated fadeIn delay-1s': animate4}">
                <div class="left">
                    <div class="top">
                        {{$t('welms.col4.i2')}}
                    </div>
                    <div class="center">
                        {{$t('welms.col4.i3')}}
                    </div>
                    <div class="bottom">
                        {{$t('welms.col4.i4')}}
                    </div>
                </div>
                <div class="right">
                    <img src="../../assets/welmsHome/welms_pic_ru.png" alt="" v-if="$i18n.locale == 'ru'">
                    <img src="../../assets/welmsHome/welms_pic_fr.png" alt="" v-else-if="$i18n.locale == 'fr'">
                    <img src="../../assets/welmsHome/welms_pic.png" alt="" v-else>
                </div>
            </div>
        </div>
        <div class="welmshome-box6">
            <h4 ref="animate5" :class="{'animated fadeIn': animate5}">{{$t('welms.col5.i1')}}</h4>
            <div class="main">
                <div class="main-left" :class="{'animated fadeInLeft delay-1s': animate5}">
                    <div class="sid">
                        <h5>{{$t('welms.col5.i2')}}</h5>
                        <p></p>
                        <span>{{$t('welms.col5.i3')}}</span>
                    </div>
                    <div class="left-box">

                        <div class="left-box1" style="line-height: 22px;">{{$t('welms.col5.i4')}} (<a href="//welms.cn" target="_blank" style="color: #fff">https://welms.cn/</a> ).  {{$t('welms.col5.i5')}}</div>
                    </div>
                </div>
                <div class="main-right" :class="{'animated fadeInRight delay-1s': animate5}">
                    <div class="sid">
                        <h5>{{$t('welms.col5.i6')}}</h5>
                        <p></p>
                        <span>{{$t('welms.col5.i7')}}</span>
                    </div>
                    <div class="right-box">
                        <div class="right-box1">{{$t('welms.col5.i8')}}</div>
                        <div class="right-box1">{{$t('welms.col5.i9')}}</div>
                        <div class="right-box1">{{$t('welms.col5.i10')}}</div>
                        <div class="right-box1">{{$t('welms.col5.i11')}}</div>
                        <div class="right-box1">{{$t('welms.col5.i12')}}</div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
        <popup :show.sync="show" />
    </div>
</template>
<script>
import Head from '../../components/head';
import Footer from '../../components/footer';
import Popup from '../../components/popup';
import scroll from '../mixin/scroll';

export default {
    components: {
        Head,
        Footer,
        Popup,
    },
    mixins: [scroll],
    data(){
        return{
            show: false,
            playerOptions: {
                preload: 'auto',
                width: '834px',
                height: '500px',
                poster: require('../../assets/welmsHome/welms_video.jpg'),
                sources: [{
                    type: "video/mp4",
                    // src: require('../../assets/video/test.mp4')
                    src:'https://welms.oss-cn-beijing.aliyuncs.com/WeLMS%E4%BA%A7%E5%93%81%E5%AE%A3%E4%BC%A0%E7%89%87%E9%AB%98%E6%B8%85.mp4'
                }]
            },
            refArray: [
                {ref: 'animate1', show: 'animate1', offset: 20},
                {ref: 'animate2', show: 'animate2',},
                {ref: 'animate3', show: 'animate3',},
                {ref: 'animate4', show: 'animate4',},
                {ref: 'animate5', show: 'animate5',},
                {ref: 'animate6', show: 'animate6',},
                {ref: 'animate7', show: 'animate7',},
                {ref: 'animate8', show: 'animate8',},
                {ref: 'animate9', show: 'animate9',},
            ],
            animate1: false,
            animate2: false,
            animate3: false,
            animate4: false,
            animate5: false,
            animate6: false,
            animate7: false,
            animate8: false,
            animate9: false,
        };   
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
}
</script>
<style lang="less">
.welmshome {
    *{
        box-sizing: border-box;
    }
    .welmshome-box1 {
        background-image: url('../../assets/welmsHome/welms_bg.jpg');
        background-size: cover;
        background-position: center;
        height: 700px;
        box-sizing: border-box;
        padding-top: 200px;
        color: #ffffff;
        text-align: center;
        .top-box{
            width: 1200px;
            height: 500px;
            margin: 0 auto;
            border-top:6px solid  #FD8E0D;
            background: #ffffff;
            display: flex;
            margin-top: 50px;
            .video{
                width: 834px;
                height: 500px;
                img{
                    width: 100%;
                    float: left;
                }
                .video-player-box{
                    .vjs-loading-spinner + .vjs-big-play-button {
                        background: url('../../assets/icon/play_icon.png');
                        width: 70px;
                        height: 70px;
                        border: none;
                        background-size: 100% 100%;
                        left: 50%;
                        top: 50%;
                        transform: translateX(-50%) translateY(-50%);
                        span {
                            display: none;
                        }
                    }
                .vjs-loading-spinner + .vjs-icon-placeholder {
                    display: none;
                }
            }
        }
            .text{
                width: 367px;
                height: 500px;
                background: #fff;
                // box-shadow: -2px -2px 19px #000;
                .welms_logo{
                    width: 268px;
                    margin-top:60px;
                    margin-left: -46px;
                }
                .welms-desc{
                    width: 307px;
                    height: 180px;
                    font-size: 20px;
                    font-family: HelveticaNeue, Arial, sans-serif;
                    color: #000000;
                    line-height: 36px;
                    text-align: left;
                    margin: 36px auto 0;
                    div {
                        line-height: 28px;
                        margin-bottom: 8px;
                    }
                }
                .email-btn{
                    width: 307px;
                    margin: 35px auto 0;
                    display: flex;
                    align-items: center;
                    .more{
                        width: 70px;
                        vertical-align: middle;
                    }
                    span{
                        font-size: 20px;
                        font-family: HelveticaNeue, Arial, sans-serif;
                        color: #333333;
                        margin-left: 16px;
                    }
                }
            }
        }
    }
    .welmshome-box2{
        background-image: url('../../assets/welmsHome/welms_stay_bg.jpg');
        background-size: cover;
        background-position: center;
        height: 524px;
        box-sizing: border-box;
        color: #ffffff;
        text-align: center;
        padding-top: 146px;
        text-align: left;
        h4{
            width: 1200px;
            height: 48px;
            font-size: 48px;
            font-family: HelveticaNeue-Bold, HelveticaNeue, Arial, sans-serif;
            font-weight: bold;
            color: #333333;
            line-height: 48px;
            margin: 0 auto;
        }
        .text1{
            width: 1200px;
            height: 102px;
            font-size: 20px;
            font-family: HelveticaNeue, Arial, sans-serif;
            color: #666666;
            line-height: 34px;
            margin: 46px auto 0;
        }
        .text2{
            width: 1200px;
            height: 102px;
            font-size: 20px;
            font-family: HelveticaNeue, Arial, sans-serif;
            color: #666666;
            line-height: 34px;
            margin: 0 auto;
        }
    }
    .welmshome-box3{
        height: 822px;
        box-sizing: border-box;
        color: #ffffff;
        text-align: center;
        padding-top: 80px;
        text-align: left;
        h4{
            width: 1200px;
            height: 60px;
            font-size: 48px;
            font-family: HelveticaNeue-Bold, HelveticaNeue, Arial, sans-serif;
            font-weight: bold;
            color: #000000;
            line-height: 60px;
            margin: 0 auto;
        }
        p{
            width: 1200px;
            height: 24px;
            font-size: 24px;
            font-family: HelveticaNeue, Arial, sans-serif;
            color: #000000;
            line-height: 24px;
            margin: 30px auto 80px;
        }
        .table{
            width: 1200px;
            height: 447px;
            background-image: url('../../assets/welmsHome/welms_pic_form.png');
            background-size: cover;
            background-position: center;
            box-sizing: border-box;
            color: #ffffff;
            margin: 0 auto;
            position: relative;
            li{
                position: absolute;
            }
            .li1{
                left: 110px;
                top: 20px;
            }
            .li2{
                left: 106px;
                bottom: 138px;
            }
            .li3{
                left: 322px;
                bottom: 138px;
                color:#351E98;
            }
            .li4{
                left: 505px;
                top: 126px;
            }
            .li5{
                left: 526px;
                bottom: 20px;
            }
            .li6{
                left: 686px;
                top: 22px;
            }
            .li7{
                left: 712px;
                top: 128px;
            }
            .li8{
                left: 691px;
                top: 230px;
            }
            .li9{
                left: 703px;
                bottom: 20px;
            }
            .li10{
                right: 220px;
                top: 22px;
                color:#FD8E0D;
            }
            .li11{
                right: 213px;
                bottom: 20px;
                color:#338188;
            }
            .li12{
                right: 12px;
                bottom: 198px;
                color:#FD8E0D;
            }
            .li13{
                right: 184px;
                bottom: 301px;
                color:#FD8E0D;
            }
            .li14{
                right: 220px;
                bottom: 196px;
            }
        }
    }
    .welmshome-box4{
        background-image: url('../../assets/welmsHome/welms_feature_bg.jpg');
        background-size: cover;
        background-position: center;
        height: 764px;
        box-sizing: border-box;
        color: #ffffff;
        padding-top: 80px;
        .title{
            width: 1200px;
            display: flex;
            // justify-content: space-between;
            margin: 0 auto;
            color: #fff;    
        color: #fff;    
            color: #fff;    
            font-size: 48px;
            font-family: HelveticaNeue-Bold, HelveticaNeue, Arial, sans-serif;
            font-weight: bold;
            b{
                font-size: 24px;
                line-height: 64px;
                margin-left: 20px;
                margin-right: 20px;
            }
        }
        .content{
            width: 1200px;
            height: 496px;
            margin: 60px auto 0;
            display: flex;

            .content-box{
                width: 300px;
                height: 446px;
                // filter: blur(4px);
                padding: 54px 30px;
                img{
                    width: 50px;
                    height: 50px;
                }
                p{
                    margin-bottom: 25px;
                    margin-top: 20px;
                    font-size: 24px;
                    font-family: HelveticaNeue-Bold, HelveticaNeue, Arial, sans-serif;
                    font-weight: bold;
                    line-height: 24px;
                }
                li{
                    font-size: 16px;
                    font-family: HelveticaNeue, Arial, sans-serif;
                    margin-left: -30px;
                    margin-bottom: 22px;
                    b{
                        width: 10px;
                        height: 10px;
                        background: #415BFF;
                        display: inline-block;
                        margin-right: 20px;
                    }
                    span{
                        width: 240px;
                        display: inline-block;
                        text-align: left;
                        vertical-align: text-top;
                    }
                }
            }
            .content-box:hover{
                background: #FD8E0D;
                opacity: 0.95;
            }
            .c-box1 ,.c-box3{
                background: #000000;
                opacity: 0.85;
            }
            .c-box2,.c-box4{
                background: #000000;
                opacity: 0.5;
                margin-top: 50px;
            }
        }

    }
    .welmshome-box5{
        height: 778px;
        background: linear-gradient(133deg, #FFFAF7 0%, #F7F7F7 100%);
        box-sizing: border-box;
        padding-top: 80px;
        text-align: left;
        h4{
            width: 1200px;
            height: 48px;
            font-size: 48px;
            font-family: HelveticaNeue-Bold, HelveticaNeue, Arial, sans-serif;
            font-weight: bold;
            color: #000000;
            line-height: 48px;
            margin: 0 auto;
        }
        .cont{
            width: 1200px;
            display: flex;
            margin: 60px auto 0;
            .left{
                width: 620px;
                margin-right: 76px;
                .top{
                    width: 617px;
                    height: 140px;
                    font-size: 24px;
                    font-family: HelveticaNeue, Arial, sans-serif;
                    color: #000000;
                    line-height: 36px;
                }
                .center,.bottom{
                    width: 620px;
                    height: 162px;
                    font-size: 20px;
                    font-family: HelveticaNeue, Arial, sans-serif;
                    color: #000000;
                    line-height: 36px;
                }
                .bottom{
                    margin-top: 6px;
                }
            }
            .right{
                width: 500px;
                height: 500px;
                img{
                    width: 100%;
                }
            }
        }
    }
    .welmshome-box6{
        background-image: url('../../assets/welmsHome/welms_sub_bg.jpg');
        background-size: cover;
        background-position: center;
        height: 667px;
        box-sizing: border-box;
        color: #ffffff;
        padding-top: 74px;
        h4{
            width: 1200px;
            height: 120px;
            font-size: 48px;
            font-family: HelveticaNeue-Bold, HelveticaNeue, Arial, sans-serif;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 60px;
            margin: 0 auto 50px;
        }
        .main{
            width: 1200px;
            height: 409px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            overflow: hidden;
            .main-left,.main-right{
                width: 580px;
                height: 409px;
                background: #0E0F21;
                opacity: 0.9;
                display: flex;
            }
            .sid{
                width: 204px;
                height: 409px;
                background: #080C1B;
                opacity: 0.7985;
                padding: 56px 0px 56px 30px;
                h5{
                    height: 22px;
                    font-size: 22px;
                    font-family: HelveticaNeue-Bold, HelveticaNeue, Arial, sans-serif;
                    font-weight: bold;
                    color: #FFFFFF;
                    line-height: 22px;
                    margin-bottom: 24px;
                }
                p{
                    width: 36px;
                    height: 3px;
                    background: #FD8E0D;
                    margin-bottom: 22px;
                }
                span{
                    height: 48px;
                    font-size: 16px;
                    font-family: HelveticaNeue, Arial, sans-serif;
                    color: #FFFFFF;
                    line-height: 24px;
                }
            }
            .left-box {
                color: rbga(255, 255, 255, 0.5);
            }
            .left-box,.right-box{
                flex:1;
                padding: 56px 30px 30px;
                .left-box1,.right-box1{
                    font-size: 14px;
                    font-family: HelveticaNeue, Arial, sans-serif;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 0.5);
                    margin-bottom: 18px;
                }
            }
        }
    }
}
.lang-ru {
    .welmshome .welmshome-box6 h4 {
        font-size: 40px;
    }
    .welmshome {
        .welmshome-box3 {
            .table {
                background-image: url('../../assets/welmsHome/welms_pic_form_ru.png');
                li {
                    display: none;
                }
        }
            }
            
    }
}
.lang-fr {
     .welmshome .welmshome-box6 h4 {
        font-size: 40px;
    }
    .welmshome {
        .welmshome-box3 {
            .table {
                background-image: url('../../assets/welmsHome/welms_pic_form_fr.png');
                li {
                    display: none;
                }
        }
            }
            
    }
}


</style>